import { render, staticRenderFns } from "./RateMatrix.vue?vue&type=template&id=1b5276ec&scoped=true&"
import script from "./RateMatrix.vue?vue&type=script&lang=js&"
export * from "./RateMatrix.vue?vue&type=script&lang=js&"
import style0 from "./RateMatrix.vue?vue&type=style&index=0&id=1b5276ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5276ec",
  null
  
)

export default component.exports